import { createContext, useContext, useEffect } from "react";
import { useRest, useRestCall } from "../common/rest";
import { useUser } from "./user";
import { CMainLoading } from "./cr.ui.slide";

const PlayerContext = createContext()
export function PlayerManaged(props) {
    const { alt, ...rest } = props;
    const user = useUser();
    const [crusade, reload_c] = useRest('crusade/info')
    const loading = !Boolean(user) || !Boolean(crusade);
    const [call] = useRestCall(reload)

    function reload() {
        user.reload();
        reload_c();
    }

    useEffect(() => {
        if (crusade) {
            document.title = crusade.name;
        }
    }, [crusade])

    useEffect(() => {
        const interval = setInterval(reload, 5000)
        return () => clearTimeout(interval)
    }, [])

    return <CMainLoading loading={loading}>
        {!loading && <PlayerContext.Provider value={{
            user,
            player: user.player,
            crusade,
            reload,
            call,
        }} {...rest} />}
    </CMainLoading>
}

export function usePlayer() {
    const { user, player, reload, crusade, call } = useContext(PlayerContext)

    const usedRelics = player.order ? player.order.units.filter(u=>Boolean(u.relics)).flatMap(u => u.relics) : []

    return {
        ...player,
        user,
        crusade,
        admin: user.admin,
        reload,
        call,
        usedRelics,
    }
}